<div class="full-size hide-gt-sm flex-v-center justify-content-center">
    <div class="d-flex flex-column text-center">
        <h2>{{ 'general.warning.view.onMobile' | translate }}</h2>
    </div>
</div>